// components/Navigation/AppTopBar.jsx
import React from "react";
import { Link, useLocation } from "react-router-dom";
import ThemeDropdown from "components/ThemeDropdown";
import NotificationBell from "components/Notifications/NotificationBell";
import BugNub from "components/BugNub";
import { useAuth } from "utilities/auth";
import { isInternal } from "utilities/userType";

function Breadcrumbs() {
  const location = useLocation();
  const parts = location.pathname.split("/").filter(Boolean).slice(0, 5); // keep it tidy

  const segToLabel = (seg) =>
    seg.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  if (parts.length === 0) {
    return (
      <nav aria-label="Breadcrumbs" className="text-sm text-muted-foreground">
        <span>Home</span>
      </nav>
    );
  }

  const paths = parts.map((_, i) => "/" + parts.slice(0, i + 1).join("/"));

  return (
    <nav aria-label="Breadcrumbs" className="text-sm">
      <ol className="flex items-center gap-2 text-muted-foreground">
        <li>
          <Link className="hover:text-foreground transition" to="/">
            Home
          </Link>
        </li>
        {parts.map((seg, i) => (
          <li key={paths[i]} className="flex items-center gap-2">
            <span className="text-border">/</span>
            {i < parts.length - 1 ? (
              <Link className="hover:text-foreground transition" to={paths[i]}>
                {segToLabel(seg)}
              </Link>
            ) : (
              <span className="text-foreground">{segToLabel(seg)}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

// SOUND-239: dropped backdrop-blur from the <header> — it created a stacking
// context that prevented modal overlays (z-50) from stacking above the topbar
// (z-40), causing a ~56px visible gap at the top of fullscreen modals.
export default function AppTopBar() {
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-40 bg-background border-b border-border">
      <div className="container h-14 flex items-center justify-between">
        <Breadcrumbs />
        <div className="flex items-center gap-2">
          {/* In-app notification center — internal-first (SOUND-515). */}
          {isInternal(user) && <NotificationBell />}
          <BugNub />
          <ThemeDropdown />
        </div>
      </div>
    </header>
  );
}
